import React, { FC, memo, useMemo, useState } from 'react';
import { useRequest } from 'ahooks';
import { Select } from 'udesk-ui';
import { SelectProps } from 'udesk-ui/lib/select';
import { LanguageEnum } from 'src/components/pages/components/LanguageSelect/const';
import { postFieldDataSearchTemplate } from 'src/api/field/data/search-template';
import { FieldFoundResponse, FieldWithTypeWrapperResponse } from 'src/api/types';
import { getTypeLabel } from './utils';
import isNil from 'lodash/isNil';
import UdeskLocales from 'UdeskLocales';
export * from './const';

interface TemplateProps extends Omit<SelectProps<string>, 'value' | 'onChange'> {
    value?: FieldFoundResponse;
    onChange?: (v?: TemplateProps['value']) => void;
    sourceList?: number[] | number;
    typeList?: number[];
    lang?: number;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { value, onChange, sourceList, typeList, lang, ...restProps } = props;

    const [originData, setOriginData] = useState<FieldWithTypeWrapperResponse[]>();

    const [options, setOptions] = useState<
        {
            label: string;
            options: {
                value: string;
                label: string;
            }[];
        }[]
    >();

    const _sourceList = useMemo(() => {
        if (Array.isArray(sourceList)) {
            return sourceList;
        } else if (sourceList) {
            return [sourceList];
        } else {
            return [];
        }
    }, [sourceList]);

    useRequest(
        () =>
            postFieldDataSearchTemplate({
                sourceList: _sourceList,
                typeList,
                langList: !isNil(lang)
                    ? lang === LanguageEnum.All
                        ? [lang]
                        : [LanguageEnum.All, lang!]
                    : undefined,
            }),
        {
            refreshDeps: [_sourceList, typeList, lang],
            onSuccess: (res) => {
                const data = res.data?.[0].typeList ?? [];

                setOriginData(data);

                setOptions(
                    data
                        .filter((d) => !!d.fieldList?.length)
                        .map((d) => {
                            return {
                                label: getTypeLabel(d.type),
                                options:
                                    d.fieldList?.map((f) => {
                                        return {
                                            value: f.id!,
                                            label: f.label!,
                                        };
                                    }) || [],
                            };
                        })
                );
            },
        }
    );

    const onValueChange = (v: string) => {
        let t: FieldFoundResponse | undefined = undefined;
        originData?.forEach((d) => {
            if (t) {
                return;
            }
            t = d.fieldList?.find((f) => f.id === v);
        });
        onChange?.(t);
    };

    return (
        <Select
            value={value?.id}
            onChange={(v) => onValueChange(v)}
            options={options}
            showSearch
            filterOption={(input, option) =>
                ((option?.label as string) ?? '').toLowerCase().includes(input.toLowerCase())
            }
            placeholder={/* 请选择 */UdeskLocales['current'].components.randomFieldSelect.index.pleaseSelect}
            {...restProps}
        />
    );
});

export default Template;
